import { Navigate } from "react-router-dom";
import ProtectedRoute from "../components/comps/protected_route";
import Main from "../components/layout/Main";

// BOT Pages
import ItemsManagement from "../pages/bot/items/ItemsManagement";
import TemplatesManagement from "../pages/bot/templates/TemplatesManagement";
import AssignmentsManagement from "../pages/bot/assignments/AssignmentsManagement";
import BotClearance from "../pages/bot/clearance/BotClearance";
import WarehouseManagement from "../pages/bot/warehouse/WarehouseManagement";

const botRoutes = [
  {
    path: "/admin",
    element: (
      <ProtectedRoute>
        <Main />
      </ProtectedRoute>
    ),
    children: [
      // Categories & Items Management
      {
        path: "bot/items",
        element: (
          <ProtectedRoute>
            <ItemsManagement />
          </ProtectedRoute>
        ),
      },

      // Requirement Templates Management
      {
        path: "bot/templates",
        element: (
          <ProtectedRoute>
            <TemplatesManagement />
          </ProtectedRoute>
        ),
      },

      // Student Assignments Management
      {
        path: "bot/assignments",
        element: (
          <ProtectedRoute>
            <AssignmentsManagement />
          </ProtectedRoute>
        ),
      },

      // BOT Clearance Portal (Parent access)
      {
        path: "bot/clearance",
        element: (
          <ProtectedRoute>
            <BotClearance />
          </ProtectedRoute>
        ),
      },

      // Warehouse Management
      {
        path: "bot/warehouse",
        element: (
          <ProtectedRoute>
            <WarehouseManagement />
          </ProtectedRoute>
        ),
      },

      // Default redirect for /admin/bot to items
      {
        path: "bot",
        element: <Navigate to="/admin/bot/items" replace />,
      },
    ],
  },
];

export default botRoutes;
